export enum User {
  EXAMINER = 'EXAMINER',
  STUDENT = 'STUDENT',
  RECORD = 'RECORD',
  EXAM = 'EXAM',
}
